<template>
  <div class="main-ct">
    <div class="header-ct">
      <p>{{ $t('Gamification_Lets_Play') }}</p>
    </div>
    <div>
      <div class="radio-btn-ct">
        <el-button
          v-for="(game, gameIndex) in gameMap"
          :key="gameIndex"
          @click="selectGame(gameIndex)"
          :type="selectedGame === gameIndex ? 'primary' : 'default'"
        >
          {{ $t(game.label) }}
        </el-button>
      </div>
    </div>
    <div class="game-ct">
      <iframe :src="gameMap[selectedGame].gameUrl"></iframe>
      <div class="stats-ct">
        <div class="stats-header">
          <p>{{ $t('Gamification_Lets_Play_See_Data') }}</p>
        </div>
        <div class="stat-box-ct">
          <div
            class="stat-box"
            v-for="key in Object.keys(gameStats)"
            :key="key"
          >
            <div>
              <p class="stat-name">
                {{ $t(`Gamification_Lets_Play_Stat_${key}`) }}
              </p>
              <p class="stat">{{ translateGameStat(gameStats[key]) }}</p>
            </div>
          </div>
          <div class="stat-box">
            <div>
              <p class="stat-name">
                {{ $t('Gamification_Lets_Play_Account_Name') }}
              </p>
              <p class="stat">{{ $store.state.app.user.email }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'GamificationLetsPlay',
  data() {
    return {
      selectedGame: 'wheel',
      gameMap: {
        wheel: {
          label: 'Gamification_Lets_Play_Game_Wheel',
          gameUrl: `https://demo-wheels.thunderbite.com/xp-demo-do-not-touch?a=${this.$store.state.app.user.email}`,
          // Added email in game stats endpoint url because axios encodes plus address with %2B instead of +
          gameStatsEndpoint: `https://demo-wheels.thunderbite.com/api/external-api/games/export?account=${this.$store.state.app.user.email}`,
          campaign: 'xp-demo-do-not-touch'
        },
        scratchcard: {
          label: 'Gamification_Lets_Play_Game_Scratchcard',
          gameUrl: `https://demo-scratchcards.thunderbite.com/thunderbite-demo-campaign-please-do-not-changeamend?a=${this.$store.state.app.user.email}`,
          gameStatsEndpoint: `https://demo-scratchcards.thunderbite.com/api/external-api/games/export?account=${this.$store.state.app.user.email}`,
          campaign: 'thunderbite-demo-campaign-please-do-not-changeamend'
        },
        fiveReelSlot: {
          label: 'Gamification_Lets_Play_Game_Five_Reel_Slot',
          gameUrl: `https://demo-5-reel-slots.thunderbite.com/thunderbite-demo-campaign-please-do-not-changeamend?a=${this.$store.state.app.user.email}`,
          gameStatsEndpoint: `https://demo-5-reel-slots.thunderbite.com/api/external-api/games/export?account=${this.$store.state.app.user.email}`,
          campaign: 'thunderbite-demo-campaign-please-do-not-changeamend'
        }
      },
      gameStats: {
        total: '-',
        last_prize: '-',
        last_played_at: '-'
      }
    }
  },
  mounted() {
    this.getGamePlayStats()
  },
  methods: {
    selectGame(game) {
      this.selectedGame = game
      this.getGamePlayStats()
    },

    getGamePlayStats() {
      axios
        .get(
          this.gameMap[this.selectedGame].gameStatsEndpoint,
          // eslint-disable-next-line
          {
            // eslint-disable-next-line
            params: {
              campaign: this.gameMap[this.selectedGame].campaign
            }
            // eslint-disable-next-line
          }
        )
        .then(({ data }) => {
          this.gameStats = data
        })
        .catch(() => {
          this.gameStats = {
            total: '-',
            last_prize: '-',
            last_played_at: '-'
          }

          this.$message({
            message: this.$t('Gamification_Lets_Play_Error_Fetch_Data_Message'),
            type: 'error'
          })
        })
    },
    translateGameStat(stat) {
      if (stat === 'N/A') {
        return '-'
      }
      return stat
    }
  }
}
</script>

<style scoped>
.main-ct {
  background-color: #fff;
}

.header-ct {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 65px 20px 65px;

  p {
    color: #176ca1;
    font-size: 32px;
    font-weight: 600;
    line-height: 42px;
  }
}

.radio-btn-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 10px 65px;
}

.game-ct {
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: 20px 65px 60px 65px;
  gap: 20px;

  iframe {
    width: 550px;
  }
}

.stats-ct {
  width: 210px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ebeef5;
  padding: 30px 20px;
  gap: 30px;

  .stat-box-ct {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 10px;
  }
}

.stat-box {
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
  width: 100%;

  div {
    padding: 10px;
    word-break: break-word;
  }

  .stat-name {
    color: #5c6374;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  .stat {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #7e8596;
  }
}

.stats-header {
  display: flex;
  justify-content: center;

  p {
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    color: #5c6374;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationLetsPlay.vue